var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","d":"M.42,0A.42.42,0,0,0,0,.42v1.7a.42.42,0,0,0,.42.43H2.69a.42.42,0,0,0,.42-.43V.42A.42.42,0,0,0,2.69,0Zm0,.28H2.69a.14.14,0,0,1,.14.14v1.7a.14.14,0,0,1-.14.14H.42a.14.14,0,0,1-.14-.14V.42A.15.15,0,0,1,.42.28Z","key":0}),React.createElement("path",{"fillRule":"evenodd","d":"M2.89.31l-1.33.93L.22.31A.13.13,0,0,0,0,.34a.14.14,0,0,0,0,.2l1.42,1a.12.12,0,0,0,.16,0l1.41-1a.14.14,0,0,0,0-.2.14.14,0,0,0-.2,0Z","key":1})]);
}

Email.defaultProps = {"viewBox":"0 0 3.11 2.55"};

module.exports = Email;

Email.default = Email;
